/* eslint-disable max-lines */
import * as React from 'react';

export const Image = () => (
  // eslint-disable-next-line react/forbid-elements
  <svg width="377" height="162" viewBox="0 0 377 162" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2143_19714)">
      <path d="M85 184.5L85 163.266L268.57 8V184.5H85Z" fill="url(#paint0_linear_2143_19714)" />
      <path d="M-30 194.266L153.57 39V194.266H-30Z" fill="url(#paint1_linear_2143_19714)" />
      <path d="M268.57 8V184H377V65.286L268.57 8Z" fill="url(#paint2_linear_2143_19714)" />
      <path d="M153.57 39V273.958H269.501V97.286L153.57 39Z" fill="url(#paint3_linear_2143_19714)" />
    </g>
    <g clipPath="url(#clip1_2143_19714)">
      <path
        d="M159.797 99.4865C164.187 100.117 168.282 102.068 171.536 105.082C174.79 108.096 177.05 112.029 178.014 116.358L178.305 117.665L179.623 117.485L183.704 116.886L183.661 117.604L179.712 118.185L178.406 118.365L178.492 119.686C178.7 122.912 178.188 126.144 176.992 129.148C175.796 132.151 173.946 134.851 171.577 137.05C169.208 139.25 166.379 140.895 163.295 141.865C160.211 142.835 156.95 143.107 153.748 142.66C149.13 141.996 144.843 139.883 141.503 136.626C138.092 133.302 135.876 128.944 135.2 124.23C134.717 120.881 135.019 117.465 136.083 114.253C137.147 111.04 138.943 108.119 141.331 105.72C143.718 103.322 146.63 101.511 149.838 100.432C153.045 99.3523 156.459 99.0336 159.811 99.5009L159.797 99.4865ZM153.827 141.949C155.804 142.222 157.811 142.215 159.786 141.928C164.966 141.169 169.678 138.508 173.004 134.465C176.33 130.422 178.032 125.285 177.778 120.056L177.699 118.476L176.134 118.706L171.108 119.449C171.081 119.456 171.052 119.456 171.025 119.449C170.946 119.441 170.871 119.407 170.813 119.352C170.765 119.307 170.731 119.25 170.713 119.187C170.695 119.123 170.695 119.056 170.713 118.993C170.724 118.947 170.745 118.904 170.774 118.867C170.801 118.829 170.837 118.797 170.878 118.774C170.919 118.75 170.964 118.734 171.011 118.727L176.037 117.981L177.584 117.755L177.225 116.232C176.234 112.107 174.027 108.374 170.892 105.516C167.756 102.658 163.835 100.806 159.635 100.201C156.396 99.7468 153.095 100.054 149.995 101.097C146.895 102.141 144.08 103.892 141.775 106.213C139.469 108.533 137.736 111.359 136.712 114.466C135.689 117.573 135.403 120.875 135.878 124.112C136.555 128.618 138.666 132.786 141.9 135.997C145.133 139.208 149.316 141.29 153.827 141.935V141.949ZM159.973 98.065C156.932 97.5955 153.827 97.7348 150.841 98.475C147.854 99.2152 145.044 100.541 142.574 102.377C140.104 104.212 138.023 106.52 136.453 109.166C134.882 111.812 133.853 114.744 133.425 117.791C132.997 120.838 133.179 123.94 133.959 126.917C134.74 129.893 136.105 132.685 137.974 135.129C139.842 137.574 142.178 139.623 144.846 141.157C147.513 142.692 150.458 143.681 153.511 144.067C156.922 144.539 160.396 144.247 163.68 143.211C166.964 142.176 169.978 140.424 172.502 138.081C175.026 135.738 176.998 132.864 178.274 129.666C179.551 126.468 180.101 123.026 179.885 119.589L184.997 118.871L185.215 115.209L179.379 116.06C178.352 111.447 175.944 107.256 172.476 104.045C169.008 100.834 164.644 98.7555 159.965 98.0865L159.973 98.065ZM154.01 140.513C149.33 139.86 145.042 137.541 141.934 133.98C138.826 130.42 137.107 125.859 137.092 121.133C137.076 116.407 138.766 111.835 141.851 108.255C144.936 104.675 149.208 102.327 153.885 101.644C155.724 101.371 157.593 101.364 159.434 101.622C163.352 102.175 167.012 103.896 169.936 106.561C172.861 109.225 174.914 112.71 175.828 116.559L170.803 117.306C170.569 117.338 170.344 117.417 170.142 117.539C169.94 117.66 169.763 117.82 169.622 118.009C169.48 118.198 169.378 118.413 169.32 118.641C169.261 118.876 169.249 119.12 169.284 119.359C169.341 119.744 169.52 120.1 169.796 120.373C170.071 120.647 170.429 120.824 170.813 120.878C170.981 120.903 171.152 120.903 171.32 120.878L176.345 120.131C176.484 123.015 175.985 125.894 174.885 128.563C173.784 131.233 172.108 133.626 169.977 135.574C167.846 137.522 165.311 138.976 162.554 139.833C159.797 140.69 156.884 140.928 154.024 140.531L154.01 140.513Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M213.595 38.5931C214.805 36.2992 218.262 35.6244 220.254 37.2972C222.247 38.97 222.333 42.1038 221.669 44.6561C221.249 46.5019 220.386 48.218 219.156 49.6565C217.874 51.0458 216.072 52.0114 214.188 51.9827C213.226 51.9827 212.16 51.6237 211.754 50.7406"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M219.16 39.4824C217.903 40.0884 216.789 40.9533 215.89 42.0206C214.991 43.0878 214.328 44.3331 213.944 45.6747"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M213.901 52C215.187 55.6391 216.108 59.3968 216.651 63.2179"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M196.782 63.791C197.566 69.0099 198.644 74.1802 200.013 79.277"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M207.554 57.0723C206.984 63.7384 203.078 69.7403 198.311 71.3091"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M218.676 50.2051C219.311 51.081 219.415 52.2332 219.394 53.3137C219.394 54.5701 219.204 55.9486 218.277 56.7815C217.351 57.6143 215.492 57.4024 215.233 56.1783"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M210.746 27.8628C210.893 26.5562 212.796 26.1649 214.181 26.4844C215.252 26.7275 216.256 27.2014 217.124 27.8729C217.992 28.5444 218.703 29.3973 219.207 30.372C219.665 31.3096 219.887 32.3451 219.853 33.3882C219.82 34.4312 219.531 35.4501 219.013 36.3561"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M202.397 20.9557C202.099 19.1286 201.804 17.2188 202.415 15.4706C203.025 13.7224 204.852 12.2614 206.64 12.7317C207.982 13.0907 208.851 14.3614 209.512 15.5712C212.301 20.634 213.803 26.3043 213.887 32.0839C213.887 32.8018 213.787 33.7064 213.112 33.9936"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M179.472 23.5542C178.103 22.3982 177.085 20.8825 176.532 19.1784C176.044 17.4733 176.234 15.5133 177.301 14.0881C179.002 11.823 182.254 11.4928 185.076 11.7082C193.315 12.359 201.064 15.8805 206.973 21.6588C207.795 22.4701 208.639 23.565 208.28 24.6634"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M207.857 27.3516C208.044 29.1931 208.967 34.032 209.143 37.2341C209.372 41.2797 208.945 43.5627 210.169 43.7997C212.359 44.2233 214.06 37.9592 213.719 35.809"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M209.407 54.868C206.403 58.2029 202.946 61.2864 198.76 62.9593C194.574 64.6321 189.581 64.7218 185.801 62.3023C181.931 59.8326 179.946 55.2629 178.895 50.7972C176.929 42.356 177.522 33.5204 180.6 25.418"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M213.324 33.2685C211.194 30.5256 208.43 28.3413 205.268 26.9035C202.107 25.4657 198.644 24.8174 195.176 25.0145C191.709 25.2115 188.342 26.248 185.364 28.0347C182.386 29.8215 179.886 32.3049 178.081 35.2715V35.2069C176.304 35.6807 173.881 34.9556 172.793 33.4659C171.519 31.7321 172.132 29.2695 173.123 27.3634C174.857 24.0268 177.54 21.2787 180.834 19.466C181.135 19.3009 181.71 19.3404 181.606 19.6706"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M196.697 79.8099C196.892 81.0565 197.318 82.2558 197.953 83.3458C198.636 84.5268 199.555 85.7043 200.843 86.2176C202.699 86.975 204.828 86.2535 206.511 85.1981C211.393 82.1684 214.068 76.7156 215.895 71.3597C216.889 68.4588 217.711 65.5017 218.357 62.5039"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M211.216 84.8913C213.854 82.0195 215.595 78.4477 216.916 74.9046C217.991 72.0221 218.871 69.0707 219.551 66.0703"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M175.014 100.109C182.473 91.914 190.945 84.6736 199.395 77.4941"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M175.014 100.109C174.655 101.434 174.217 103.218 173.786 105.293"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M170.915 120.857C169.752 127.735 168.761 134.172 168.341 136.925"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M172.882 109.879C172.44 112.198 171.992 114.689 171.554 117.191"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M176.073 137.586C173.69 154.842 176.145 172.047 179.207 178.527"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M169.673 140.35C171.062 141.028 173.212 141.635 175.546 142.144"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M173.201 137.445H173.434H173.668C174.005 137.445 174.353 137.47 174.705 137.492H174.967L175.764 137.546L176.066 137.589L176.295 137.621L176.525 137.654C180.142 137.991 183.738 138.53 187.294 139.269"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M179.513 119.566C179.906 121.667 180.541 123.714 181.404 125.669C183.001 129.083 185.754 131.822 189.176 133.401"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M185.442 123.744C184.857 120.611 184.825 117.4 185.349 114.256C185.425 113.613 185.618 112.988 185.92 112.415C186.074 112.127 186.295 111.88 186.566 111.697C186.835 111.514 187.144 111.399 187.467 111.359C187.787 111.362 188.103 111.439 188.388 111.585C188.674 111.731 188.921 111.941 189.111 112.199C189.484 112.72 189.765 113.302 189.94 113.919C190.931 116.617 191.616 119.418 191.983 122.268"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M189.447 112.701C189.784 111.671 190.478 110.795 191.404 110.231C191.847 109.969 192.355 109.837 192.87 109.851C193.385 109.864 193.886 110.022 194.315 110.307C195.08 110.863 195.478 111.829 195.808 112.755C196.767 115.448 197.47 118.226 197.908 121.051"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M194.007 109.834C194.926 108.757 196.29 107.784 197.672 108.111C198.997 108.423 199.772 109.77 200.346 110.983C201.66 113.815 202.755 116.888 202.457 119.979"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M199.683 109.158C200.602 108.164 202.195 108.06 203.441 108.595C204.687 109.13 205.616 110.203 206.374 111.319C208.958 115.128 209.956 119.794 209.156 124.326C208.356 128.858 205.82 132.9 202.088 135.593"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M202.113 135.496C203.556 149.817 202.904 164.271 200.179 178.404"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M188.709 133.254C185.869 144.816 183.145 159.595 182.315 171.506"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M218.677 50.2051C219.312 51.081 219.416 52.2296 219.395 53.3137C219.395 54.5701 219.204 55.9486 218.278 56.7815C217.352 57.6143 215.493 57.4024 215.234 56.1783C215.234 56.1783 214.287 52.7825 214.247 52.1076C215.586 52.7753 218.677 50.2051 218.677 50.2051Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M207.556 57.0723C207.003 63.6055 202.821 69.6649 198.068 71.1834L196.607 63.8712C198.593 63.1661 200.499 62.2528 202.293 61.1465C204.14 59.9124 205.899 58.5511 207.556 57.0723Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M219.21 30.3757C218.706 29.401 217.995 28.548 217.127 27.8766C216.259 27.2051 215.255 26.7312 214.184 26.4881C213.907 26.4235 213.625 26.3839 213.341 26.3696C212.669 22.5792 211.381 18.9244 209.528 15.5502C208.857 14.3369 207.985 13.0625 206.657 12.7107C204.862 12.2405 203.038 13.7051 202.432 15.4497C202.196 16.1509 202.075 16.8854 202.073 17.6251C197.02 14.2067 191.167 12.1572 185.086 11.6769C182.265 11.4615 179.016 11.7918 177.314 14.0569C176.237 15.4928 176.051 17.4384 176.542 19.1471C176.807 20.0239 177.215 20.8511 177.749 21.5953C175.854 23.1911 174.289 25.1423 173.143 27.3388C172.149 29.2486 171.542 31.7111 172.813 33.4414C173.89 34.9311 176.32 35.6777 178.101 35.1824V35.2506C179.572 32.7873 181.526 30.6475 183.847 28.96C186.167 27.2725 188.805 26.0723 191.602 25.4316C194.399 24.791 197.296 24.7232 200.12 25.2323C202.943 25.7415 205.635 26.8171 208.032 28.3942C208.355 30.6378 209.03 34.5255 209.18 37.2142C209.41 41.2634 208.979 43.5428 210.207 43.7797C211.865 44.0992 213.244 40.5813 213.667 37.9213C214.384 37.2634 215.242 36.7796 216.176 36.5075C217.11 36.2354 218.094 36.1825 219.052 36.3526C219.564 35.443 219.847 34.422 219.874 33.3784C219.902 32.3348 219.674 31.3003 219.21 30.365V30.3757Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M176.525 137.622C176.363 138.771 175.638 141.732 175.534 142.109C175.534 142.109 175.534 142.134 175.534 142.149C173.197 141.628 171.047 141.018 169.661 140.354C170.932 139.5 172.114 138.521 173.19 137.432H173.656C173.994 137.432 174.339 137.46 174.69 137.482H174.956L175.753 137.536L176.525 137.622Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M247.049 87.7181C238.553 80.6032 229.173 74.5905 219.843 68.6172"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M253.145 105.269C250.933 98.2761 248.582 91.2403 247.042 87.7188"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M254.3 108.99C256.892 117.326 259.031 124.674 259.031 124.674"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M251.062 124.992C255.754 141.771 255.646 159.145 253.482 165.98"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M252.2 129.45C256.148 127.986 259.501 126.327 259.132 125.006C258.999 124.547 258.457 124.288 257.609 124.209L257.451 124.188C257.355 124.177 257.257 124.177 257.161 124.188H256.884C256.525 124.188 256.166 124.188 255.725 124.238H255.563C254.932 124.292 254.232 124.385 253.485 124.511L252.921 124.611C252.178 124.744 251.403 124.906 250.606 125.085C249.913 125.247 249.206 125.419 248.495 125.602L245.878 126.32C243.775 126.927 241.764 127.559 240.135 128.151"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M237.516 122.631C240.273 120.915 245.198 116.938 245.158 110.16"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M239.927 112.546C240.084 109.362 239.683 106.174 238.742 103.127C238.579 102.499 238.302 101.906 237.924 101.379C237.731 101.117 237.479 100.906 237.188 100.761C236.906 100.599 236.581 100.525 236.257 100.549C235.932 100.574 235.622 100.695 235.368 100.898C235.103 101.083 234.886 101.33 234.736 101.616C234.437 102.183 234.237 102.798 234.144 103.432C233.522 106.238 233.222 109.106 233.25 111.979"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M234.438 102.17C233.964 101.193 233.157 100.418 232.162 99.9835C231.688 99.7824 231.166 99.7213 230.658 99.8076C230.151 99.8918 229.677 100.116 229.29 100.454C228.605 101.107 228.332 102.134 228.141 103.081C227.556 105.879 227.237 108.725 227.187 111.582"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M229.542 99.9148C228.487 98.96 227.008 98.1918 225.683 98.7016C224.412 99.1934 223.827 100.618 223.418 101.932C222.495 104.915 221.828 108.107 222.546 111.147"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M223.828 100.016C222.787 99.1469 221.182 99.2582 220.026 99.9582C218.87 100.658 218.088 101.864 217.492 103.056C215.444 107.18 215.086 111.941 216.494 116.325C217.902 120.709 220.964 124.371 225.03 126.533"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M224.986 126.439C225.489 140.823 228.087 155.056 232.697 168.69"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M237.957 122.406C242.329 133.477 247.028 147.753 249.444 159.449"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M252.201 129.453C256.15 127.988 259.503 126.33 259.133 125.009C258.763 123.688 254.98 124.097 250.607 125.088C250.945 126.287 252.201 129.453 252.201 129.453Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M186.803 39.1385C186.803 39.3978 186.734 39.6524 186.603 39.8764C186.473 40.1005 186.285 40.2859 186.06 40.4136C185.834 40.5414 185.579 40.607 185.319 40.6037C185.06 40.6004 184.807 40.5284 184.584 40.3949C184.408 40.2931 184.254 40.1572 184.13 39.9951C184.007 39.833 183.917 39.648 183.866 39.4508C183.816 39.2551 183.806 39.051 183.838 38.8513C183.902 38.3703 184.66 38.1334 185.424 38.1513C186.06 38.1513 186.734 38.3595 186.803 38.6646C186.824 38.8219 186.824 38.9813 186.803 39.1385Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M200.39 39.5933C200.373 39.8006 200.315 40.0025 200.219 40.187C200.123 40.3715 199.991 40.5349 199.83 40.6677C199.67 40.8004 199.485 40.8998 199.286 40.96C199.087 41.0202 198.877 41.04 198.671 41.0183C198.464 40.9965 198.263 40.9336 198.081 40.8333C197.899 40.7329 197.738 40.5972 197.609 40.434C197.48 40.2708 197.385 40.0835 197.329 39.883C197.274 39.6825 197.259 39.4729 197.285 39.2666C197.357 38.7676 198.114 38.5235 198.944 38.5486C199.611 38.5702 200.319 38.7748 200.38 39.0907C200.407 39.2569 200.41 39.4261 200.39 39.5933Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M181.665 40.0377C182.131 39.4289 182.751 38.9544 183.46 38.6628C184.578 38.2735 185.793 38.2634 186.917 38.6341C187.891 38.9251 188.732 39.5489 189.293 40.3966"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M195.02 40.4982C195.501 39.8634 196.143 39.3679 196.879 39.0623C198.056 38.6693 199.328 38.6693 200.505 39.0623C201.53 39.373 202.417 40.0271 203.017 40.9146"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M194.909 35.3651C195.521 34.8687 196.238 34.5176 197.006 34.3384C198.373 34.066 199.782 34.0868 201.141 34.3994C202.219 34.6003 203.22 35.0975 204.031 35.8353"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M191.996 49.4873L187.986 49.0637C189.723 44.8781 191.45 41.1161 190.438 36.7187L190.323 36.5859C189.709 35.9577 188.6 35.394 187.16 35.071C185.673 34.7392 184.133 34.7172 182.637 35.0064C181.8 35.1869 181.014 35.5551 180.34 36.0833"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M193.265 55.0715C187.248 55.8792 185.777 54.4541 184.782 51.7402"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M244.904 106.476C244.904 106.476 243.001 102.553 238.981 104.01"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M179.487 115.963C179.487 115.963 181.393 112.039 185.414 113.496"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M215.769 110.744L206.795 112.058L208.328 115.461L216.16 114.32L215.769 110.744Z" fill='var(--text-primary-default)' />
      <path
        d="M277.063 102.169C276.894 102.147 276.722 102.147 276.553 102.169L239.601 107.223L239.96 110.813L260.608 108.142L262.761 122.86C262.817 123.244 262.996 123.599 263.271 123.873C263.546 124.147 263.903 124.324 264.287 124.378C264.456 124.401 264.628 124.401 264.797 124.378C265.267 124.309 265.69 124.056 265.974 123.675C266.258 123.294 266.38 122.816 266.312 122.346L264.158 107.628L275.286 106.002L278.122 125.426C278.176 125.811 278.355 126.166 278.632 126.439C278.907 126.713 279.263 126.89 279.647 126.945C279.818 126.968 279.991 126.968 280.161 126.945C280.631 126.875 281.054 126.621 281.337 126.24C281.62 125.858 281.741 125.38 281.672 124.909L278.578 103.712C278.523 103.326 278.344 102.969 278.068 102.693C277.793 102.418 277.434 102.24 277.048 102.186L277.063 102.169Z"
        fill='var(--text-primary-default)'
      />
      <path
        d="M156.818 142.754C168.745 142.754 178.414 133.085 178.414 121.158C178.414 109.231 168.745 99.5625 156.818 99.5625C144.891 99.5625 135.222 109.231 135.222 121.158C135.222 133.085 144.891 142.754 156.818 142.754Z"
        stroke='var(--text-primary-default)'
        strokeWidth="1.79486"
      />
      <path d="M183.82 117.281L170.43 119.162" stroke='var(--text-primary-default)' strokeWidth="1.43589" />
      <path
        d="M296.394 86.6573L291.781 87.5152C287.244 88.3624 282.85 85.2609 281.974 80.5692L281.091 75.8164L280.097 76.0031L280.983 80.7523C281.852 85.4189 278.887 89.9168 274.332 90.7639L269.719 91.6219L269.909 92.645L274.522 91.7871C279.063 90.9435 283.457 94.0413 284.329 98.7331L285.216 103.486L286.206 103.299L285.323 98.55C284.451 93.8834 287.42 89.3855 291.971 88.5383L296.584 87.6804L296.491 87.167L296.394 86.6573Z"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M144.962 91.9284L142.553 91.3182C141.982 91.1645 141.447 90.8999 140.978 90.5395C140.51 90.1791 140.117 89.7299 139.822 89.2175C139.527 88.7052 139.336 88.1397 139.259 87.5534C139.183 86.9672 139.222 86.3716 139.376 85.8007L140.004 83.3167L139.487 83.1875L138.859 85.668C138.583 86.8295 137.857 87.8337 136.84 88.4598C135.824 89.0859 134.6 89.2825 133.439 89.0064L131.03 88.3961L130.894 88.931L133.302 89.5413C133.873 89.6949 134.408 89.9595 134.877 90.32C135.345 90.6805 135.738 91.1298 136.033 91.6422C136.327 92.1546 136.518 92.7201 136.594 93.3064C136.67 93.8926 136.63 94.488 136.476 95.0586L135.847 97.5428L136.368 97.672L136.996 95.1915C137.272 94.03 137.998 93.0257 139.015 92.3996C140.031 91.7736 141.255 91.5769 142.417 91.853L144.825 92.4633L144.893 92.194L144.962 91.9284Z"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M279.91 138.447L277.953 138.623C277.487 138.658 277.019 138.601 276.574 138.455C276.13 138.309 275.72 138.076 275.366 137.771C275.011 137.466 274.721 137.094 274.511 136.677C274.301 136.259 274.175 135.804 274.141 135.338L273.958 133.324L273.538 133.36L273.717 135.378C273.766 135.842 273.723 136.312 273.59 136.76C273.457 137.208 273.237 137.626 272.943 137.989C272.648 138.352 272.285 138.653 271.874 138.876C271.463 139.099 271.012 139.238 270.548 139.287L268.595 139.463L268.631 139.893L270.587 139.721C271.053 139.686 271.522 139.743 271.966 139.889C272.41 140.034 272.82 140.266 273.175 140.571C273.529 140.876 273.82 141.247 274.031 141.664C274.241 142.081 274.368 142.536 274.403 143.002L274.582 145.02L275.002 144.98L274.823 142.966C274.774 142.501 274.817 142.031 274.949 141.583C275.082 141.135 275.302 140.717 275.597 140.354C275.891 139.991 276.254 139.689 276.665 139.467C277.077 139.244 277.528 139.105 277.993 139.057L279.949 138.881L279.927 138.662L279.91 138.447Z"
        stroke='var(--text-primary-default)'
        strokeWidth="0.717943"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2143_19714"
        x1="176.785"
        y1="-51"
        x2="176.785"
        y2="182.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor='var(--icon-main-default)' />
        <stop offset="1" stopColor='var(--theme-white)' />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2143_19714"
        x1="61.7851"
        y1="39"
        x2="61.7851"
        y2="262.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor='var(--icon-main-default)' />
        <stop offset="1" stopColor='var(--theme-white)' />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2143_19714"
        x1="302.68"
        y1="7.99043"
        x2="302.68"
        y2="280.574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor='var(--brand-pink)' />
        <stop offset="0.3727" stopColor='var(--surface-negative-default)' />
        <stop offset="0.5069" stopColor='var(--surface-neutral-default)' />
        <stop offset="0.6026" stopColor='var(--surface-main-default)' />
        <stop offset="0.68" stopColor='var(--stroke-divider-default)' />
        <stop offset="0.7463" stopColor='var(--brand-iris)' />
        <stop offset="0.805" stopColor='var(--brand-sky)' />
        <stop offset="0.8582" stopColor='var(--brand-cornflowerblue)' />
        <stop offset="0.907" stopColor="#6299FE" />
        <stop offset="0.9524" stopColor='var(--brand-azure)' />
        <stop offset="0.9927" stopColor='var(--icon-main-default)' />
        <stop offset="1" stopColor='var(--icon-main-default)' />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2143_19714"
        x1="187.68"
        y1="38.9904"
        x2="187.68"
        y2="311.574"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor='var(--brand-pink)' />
        <stop offset="0.3727" stopColor='var(--surface-negative-default)' />
        <stop offset="0.5069" stopColor='var(--surface-neutral-default)' />
        <stop offset="0.6026" stopColor='var(--surface-main-default)' />
        <stop offset="0.68" stopColor='var(--stroke-divider-default)' />
        <stop offset="0.7463" stopColor='var(--brand-iris)' />
        <stop offset="0.805" stopColor='var(--brand-sky)' />
        <stop offset="0.8582" stopColor='var(--brand-cornflowerblue)' />
        <stop offset="0.907" stopColor="#6299FE" />
        <stop offset="0.9524" stopColor='var(--brand-azure)' />
        <stop offset="0.9927" stopColor='var(--icon-main-default)' />
        <stop offset="1" stopColor='var(--icon-main-default)' />
      </linearGradient>
      <clipPath id="clip0_2143_19714">
        <rect width="377" height="162" fill='var(--theme-white)' />
      </clipPath>
      <clipPath id="clip1_2143_19714">
        <rect width="166.545" height="167.6" fill='var(--theme-white)' transform="translate(130.455 11.2852)" />
      </clipPath>
    </defs>
  </svg>
);
